import React, { useEffect, useState } from 'react';
import { useAuth } from './AuthContext';
import { useNavigate } from 'react-router-dom';
import Spinner from './Components/Spinner';
import CarCard from './Components/CarCard';

function SavedCars() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [cars, setCars] = useState(null); // null = loading

  useEffect(() => {
    if (!user?.id) {
      navigate('/login');
      return;
    }

    fetch(`${process.env.REACT_APP_API_BASE}/saved/full/${user.id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    })
      .then(res => {
        if (!res.ok) throw new Error('Failed to load saved cars');
        return res.json();
      })
      .then(data => setCars(data))
      .catch(err => {
        console.error(err);
        setCars([]);
      });
  }, [user, navigate]);

  const handleCarClick = (car) => {
    navigate(`/car/${car.id}`);
  };

  if (cars === null) return <Spinner />;

  return (
    <div style={{ padding: "2rem", backgroundColor: "#f9f9f9" }}>
      <h2 style={{
        fontSize: "2rem",
        color: "#004D40",
        marginBottom: "1.5rem",
        textAlign: "center"
      }}>
        Your Saved Cars
      </h2>

      {cars.length === 0 ? (
        <p style={{ textAlign: 'center', color: '#777' }}>
          You haven’t saved any cars yet.
        </p>
      ) : (
        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
          gap: "1.5rem"
        }}>
          {cars.map(car => (
            <CarCard
              key={car.id}
              car={car}
              loggedInUser={user.id}
              saved={true}
              onClick={handleCarClick}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default SavedCars;
